import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-6">
            <Link to="/" className="flex-shrink-0">
              <img
                src="https://static.readdy.ai/image/c5f8f34d4f8bde8dadcc5d50fcd889fd/30cd5c946db28922bece6f59f0351006.jpeg"
                alt="KaliKare Logo"
                className="h-16 w-16 rounded-lg"
                loading="eager"
                fetchPriority="high"
              />
            </Link>
            <a
              href="https://boltintakeapp.com/applicant/add_new_caregiver/268"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden lg:flex items-center gap-2 bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 py-3 rounded-lg hover:from-orange-600 hover:to-orange-700 transition-all duration-300 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              <i className="fas fa-dollar-sign"></i>
              Apply Online
            </a>
          </div>

          <div className="hidden lg:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-purple-700' : 'text-gray-900 hover:text-purple-700'
              }`}
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-purple-700' : 'text-gray-900 hover:text-purple-700'
              }`}
            >
              About Us
            </Link>
            <Link
              to="/services"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-purple-700' : 'text-gray-900 hover:text-purple-700'
              }`}
            >
              Services
            </Link>
            <Link
              to="/contact"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-purple-700' : 'text-gray-900 hover:text-purple-700'
              }`}
            >
              Contact
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100 cursor-pointer"
          >
            <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'} text-xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-4 py-4 space-y-3">
            <Link
              to="/"
              className="block px-4 py-2 text-sm font-medium text-gray-900 hover:bg-purple-50 rounded-lg cursor-pointer"
            >
              Home
            </Link>
            <Link
              to="/about"
              className="block px-4 py-2 text-sm font-medium text-gray-700 hover:bg-purple-50 rounded-lg cursor-pointer"
            >
              About Us
            </Link>
            <Link
              to="/services"
              className="block px-4 py-2 text-sm font-medium text-gray-700 hover:bg-purple-50 rounded-lg cursor-pointer"
            >
              Services
            </Link>
            <Link
              to="/contact"
              className="block px-4 py-2 text-sm font-medium text-gray-700 hover:bg-purple-50 rounded-lg cursor-pointer"
            >
              Contact
            </Link>
            <a
              href="https://boltintakeapp.com/applicant/add_new_caregiver/268"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 py-3 rounded-lg hover:from-orange-600 hover:to-orange-700 transition-all duration-300 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              <i className="fas fa-dollar-sign"></i>
              Apply Online
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}